import _extends from "@babel/runtime/helpers/extends";
import { Box, Text, Loader, IconButton } from '@wix/design-system';
import React from 'react';
import { useIsHarmonyTheme } from '../../context/HarmonyTheme';
const SharedContainerProps = {
  direction: 'vertical',
  backgroundColor: '#FFFFFF',
  maxWidth: '985px',
  width: '100%'
};
export const CoreDomainSearchBaseLayout = {
  // Section Containers
  SearchContainer: _ref => {
    let {
      children,
      ...props
    } = _ref;
    return /*#__PURE__*/React.createElement(Box, _extends({
      zIndex: 1,
      borderRadius: "12px"
    }, SharedContainerProps, props), children);
  },
  StatusContainer: _ref2 => {
    let {
      children,
      ...props
    } = _ref2;
    return /*#__PURE__*/React.createElement(Box, _extends({}, SharedContainerProps, {
      backgroundColor: "transparent"
    }, props), children);
  },
  StatusComponent: () => null,
  InputContainer: _ref3 => {
    let {
      children,
      ...props
    } = _ref3;
    const isHarmonyTheme = useIsHarmonyTheme();
    return /*#__PURE__*/React.createElement(Box, _extends({
      direction: "horizontal",
      verticalAlign: "middle",
      width: "100%",
      padding: isHarmonyTheme ? 'SP3 SP3 SP3 SP2' : '6px SP3 6px SP2',
      flex: 1,
      gap: "SP1"
    }, props), children);
  },
  ClearFiltersContainer: _ref4 => {
    let {
      children,
      ...props
    } = _ref4;
    return /*#__PURE__*/React.createElement(Box, _extends({
      verticalAlign: "middle"
    }, props), children);
  },
  ToolBarContainer: _ref5 => {
    let {
      children,
      ...props
    } = _ref5;
    return /*#__PURE__*/React.createElement(Box, _extends({
      direction: "horizontal",
      gap: "SP5",
      verticalAlign: "middle",
      flexWrap: "wrap",
      width: "100%",
      zIndex: 1
    }, props), children);
  },
  AdditionalToolsContainer: _ref6 => {
    let {
      children,
      ...props
    } = _ref6;
    return /*#__PURE__*/React.createElement(Box, _extends({
      direction: "horizontal",
      gap: "SP2",
      verticalAlign: "middle",
      flex: 1
    }, props), children);
  },
  ErrorContainer: _ref7 => {
    let {
      children,
      ...props
    } = _ref7;
    return /*#__PURE__*/React.createElement(Box, _extends({
      direction: "vertical",
      gap: "SP2",
      padding: "SP4",
      backgroundColor: "#FFF5F5",
      borderRadius: "8px",
      border: "1px solid #FEB2B2"
    }, props), children);
  },
  // UI Elements
  LoadingIndicator: _ref8 => {
    let {
      size = 'medium'
    } = _ref8;
    return /*#__PURE__*/React.createElement(Box, {
      align: "center",
      padding: "SP4"
    }, /*#__PURE__*/React.createElement(Loader, {
      size: size
    }));
  },
  ActionButton: _ref9 => {
    let {
      children,
      ...props
    } = _ref9;
    return /*#__PURE__*/React.createElement(IconButton, props, children);
  },
  // Specialized Containers
  FilterGroup: _ref10 => {
    let {
      title,
      children,
      ...props
    } = _ref10;
    return /*#__PURE__*/React.createElement(Box, _extends({
      direction: "vertical",
      gap: "SP2"
    }, props), title && /*#__PURE__*/React.createElement(Text, {
      size: "small",
      weight: "bold"
    }, title), /*#__PURE__*/React.createElement(Box, {
      direction: "horizontal",
      gap: "SP2"
    }, children));
  }
};
//# sourceMappingURL=CoreDomainSearchBaseLayout.js.map